import React, { Component } from "react";
import { connect } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import getLogoBranding from "utils/getLogoBranding.js";
import Request from '../config/Request.js'
class Activation extends Component {
  constructor(props) {
    super(props);
    this.onRead = this.onRead.bind(this)
    this.onReadSuccess  = this.onReadSuccess.bind(this)
    this.onReadFailed   = this.onReadFailed.bind(this)
    this.state = {
           error : null
    }
 }
  onRead(data) {
    Request(
      "get",
      "verivication-user", 
      {},
      {},
      [data],
      this.onReadSuccess,
      this.onReadFailed,
    )
  }
  onReadSuccess(response){
      this.setState({ error : false })
  }
  onReadFailed(error){
    this.setState({ error : true })
  } 
  componentDidMount() {
   this.onRead(this.props.match.params.token)
 
 }
  
  render() {
    return (
      <div className="app flex-row align-items-center">
        <ToastContainer
          position="top-center"
          type="default"
          autoClose={5000}
          hideProgressBar={true}
          newestOnTop={false}
          closeOnClick
          pauseOnHover
        />
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="card text-center">
                <center>
                <div>
                    <div>
                        <br/>
                      <img
                        src={getLogoBranding(
                          "login"
                        )}
                        alt="assetvault-logo"
                        width="150"
                        Class="card-img-top"
                      />
                    </div>
                </div>
                </center>
                  {this.state.error ? (
                    <div className="card-block">
                    <h2>Failed to Activated</h2>
                    <br/>
                    </div>
                  ) : ( 
                      <div className="card-block">
                      <h2>Your account has been Activated</h2>
                      <hr/>
                      <p>your registration has been verified, please login in the mobile application</p>
                    </div>
                )}
            </div>
             
            </div>
          </div>
        </div>
    </div>
    
    )
  }
}

const mapStateToProps = state => {
  return {
    UserReducer: state.UserReducer,
    TenantReducer: state.TenantReducer
  };
};

const mapDispatchToProps = dispatch => {
  return {
    RunRedux: data => {
      dispatch(data);
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Activation);



// WEBPACK FOOTER //
// ./src/App/Activation/index.js